define(function(require, exports, module) {
    'use strict';

    const core = require('core');
    const QuickDepositService = require('modules/cashier/quick-deposit/quick-deposit.service');
    const { dispatcher } = require('bundle');
    const user = require('user');
    const config = require('config');

    module.exports = QuickDepositService.extend({

        subscribe: function() {
            this.listenTo(core, { 'auth:login': this.updateIsQuickDepositEnabledByIMS });
            this.listenTo(core, {
                'auth:login auth:logout deposit:success quickDeposit:updated': this.setQuickDepositAvailability
            });
        },

        isQuickDepositAvailableByCashierMethods: async function() {
            try {
                await this.methods.fetch();
            } catch (e) {
                if (e.data.errorCode === 1014) {
                    this.set('isQuickDepositAvailable', false);
                    if (dispatcher) {
                        dispatcher.dispatch('quickDeposit:setIsAvailable', { isQuickDepositAvailable: false });
                    }
                }
            }

            return Boolean(this.methods.getMethod()?.get('quickDeposit'));
        },

        setQuickDepositAvailability: async function() {
            let isAvailable = config.get('isQuickDepositEnabled')
                && user.isLoggedIn()
                && this.get('isQuickDepositEnabledByIMS')
                && await this.isQuickDepositAvailableByCashierMethods();
            this.set('isQuickDepositAvailable', Boolean(isAvailable));

            if (dispatcher) {
                dispatcher.dispatch('quickDeposit:setIsAvailable', { isQuickDepositAvailable: Boolean(isAvailable) });
            }
        }
    });
});
